/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React, { useRef, useEffect } from 'react';
import '../../styles/components/controlVariations/checkbox.css';

export interface CheckboxProps {
	id: string;
	name?: string;
	checked: boolean | 'indeterminate';
	onChange: (checked: boolean | 'indeterminate') => void;
	label: string;
	disabled?: boolean;
	triState?: boolean; // 🔥 NEW PROP
	size?: number;
	checkedColor?: string;
	uncheckedColor?: string;
	indeterminateColor?: string;
	borderColor?: string;
	labelColor?: string;
	labelFontSize?: number;
	className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
	id,
	name,
	checked,
	onChange,
	label,
	disabled = false,
	triState = false, // 🔥 default is false (only two states)
	size = 20,
	checkedColor = '#007bff',
	uncheckedColor = '#ccc',
	indeterminateColor = '#007bff',
	borderColor = 'Gray',
	labelColor = '#000',
	labelFontSize = 16,
	className = '',
}) => {
	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			if (checked === 'indeterminate') {
				inputRef.current.indeterminate = true;
				inputRef.current.checked = false;
			} else {
				inputRef.current.indeterminate = false;
				inputRef.current.checked = checked;
			}
		}
	}, [checked]);

	const handleChange = () => {
		if (!disabled) {
			// 🔥 If triState mode is ON, cycle through all three
			if (triState) {
				if (checked === false) onChange(true);
				else if (checked === true) onChange('indeterminate');
				else onChange(false);
			} else {
				// 🔥 Otherwise toggle only between true and false
				onChange(checked === true ? false : true);
			}
		}
	};

	const handleSquareClick = (e: React.MouseEvent) => {
		e.preventDefault();
		if (!disabled) {
			inputRef.current?.click();
		}
	};

	const handleSquareKeyDown = (e: React.KeyboardEvent) => {
		if (disabled) return;
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault();
			inputRef.current?.click();
		}
	};

	const getCheckboxStyle = (): React.CSSProperties => {
		if (checked === 'indeterminate') {
			return {
				width: size,
				height: size,
				borderColor: indeterminateColor,
				backgroundColor: indeterminateColor,
			};
		} else if (checked) {
			return {
				width: size,
				height: size,
				borderColor: checkedColor,
				backgroundColor: checkedColor,
			};
		} else {
			return {
				width: size,
				height: size,
				borderColor: borderColor,
				backgroundColor: 'transparent',
			};
		}
	};

	const labelStyle: React.CSSProperties = {
		color: labelColor,
		fontSize: `${labelFontSize}px`,
	};

	const squareStyle: React.CSSProperties = {
		...getCheckboxStyle(),
		cursor: disabled ? 'not-allowed' : 'pointer',
	};

	return (
		<div className={`checkbox-container ${className}`}>
			<input
				type="checkbox"
				id={id}
				name={name}
				ref={inputRef}
				onChange={handleChange}
				disabled={disabled}
				className="checkbox-input"
			/>

			<span
				role="checkbox"
				aria-checked={
					checked === 'indeterminate' ? 'mixed' : Boolean(checked)
				}
				aria-disabled={disabled}
				tabIndex={disabled ? -1 : 0}
				onClick={handleSquareClick}
				onKeyDown={handleSquareKeyDown}
				className={`checkbox-custom ${disabled ? 'disabled' : ''}`}
				style={squareStyle}
			/>

			<label
				htmlFor={id}
				className={`checkbox-label ${disabled ? 'disabled' : ''}`}
				style={labelStyle}
			>
				{label}
			</label>
		</div>
	);
};

export default Checkbox;
